import React from 'react';

const ErrorBoundaryFallbackComponent = () => (
  <div
    css={`
      display: flex;
      flex-direction: column;
      gap: 16px;
      height: 100%;
      width: 100%;
      align-items: center;
      justify-content: center;
      padding: 32px;
    `}
  >
    <div
      css={`
        font-weight: bold;
      `}
    >
      Ooooops! Something went wrong.
    </div>
    <div
      css={`
        color: #666;
        font-size: 14px;
      `}
    >
      {/* <pre>{error.message}</pre> */}
    </div>
  </div>
);

export default ErrorBoundaryFallbackComponent;
